import i18n from "@/common/i18n";

export function getFormattedDateToHour(dateString: string | null): string {
  if (!dateString) return "—";
  const isoString = dateString.replace(" ", "T") + "Z";
  const date = new Date(isoString);

  if (Number.isNaN(date.getTime())) return "—";

  const currentLang = i18n.language || "en-US";

  const formattedDate = date.toLocaleDateString(currentLang, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  // The language's own clock: 12-hour in English, 24-hour in Portuguese,
  // Spanish, French, Chinese and Japanese.
  const formattedTime = date.toLocaleTimeString(currentLang, {
    hour: "numeric",
    minute: "numeric",
  });

  return `${formattedDate} ${formattedTime}`;
}

export function formatDuration(seconds: number | null): string {
  if (seconds === null) return "—";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const hoursString = hours.toString();
  const minutesString = minutes.toString().padStart(2, "0");
  const secondsString = secs.toString().padStart(2, "0");

  return `${hoursString}:${minutesString}:${secondsString}`;
}

// "Nov 3 · 3:30 PM": a short date and the time (recent dictated reports).
export function getShortDateAndTime(dateString: string | null): string {
  if (!dateString) return "";
  const date = new Date(dateString.replace(" ", "T") + "Z");
  if (Number.isNaN(date.getTime())) return "";
  const language = i18n.language || "en-US";
  return `${date.toLocaleDateString(language, {
    month: "short",
    day: "numeric",
  })} · ${date.toLocaleTimeString(language, {
    hour: "numeric",
    minute: "numeric",
  })}`;
}
